// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL || 'https://fjtqjybucxeyvbzjnjiy.supabase.co',
  import.meta.env.VITE_SUPABASE_PUBLISHABLE || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZqdHFqeWJ1Y3hleXZiempuaml5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYyNzk1MjEsImV4cCI6MjA2MTg1NTUyMX0.Ay6yDyVu-gdmJN_iLoiTXNvufh_aoybNGZMGD0TWCj4'
);
